import { push } from 'react-router-redux';

//
// No Reducers defined
//

// Action
export function searchForId(id) {
  return (dispatch, getState) => {
    // Get full state tree to access the recordlist state
    const state = getState();

    //
    // Get 'rfq' or 'order' from recordlist state
    //
    // state.recordList is part of the state from the RecordList component
    // destructuring below is equivalent the the following two lines
    // const type=state.recordList.type;
    // const filterQuerystring=state.recordList.filterQuerystring;
    //
    const { type, filterQuerystring } = state.recordList;


    // build equiv of "order|rfq/8?orderStatuses=Executed"
    dispatch(push(`/${type}/${id}${filterQuerystring}`));
  };
}



// WEBPACK FOOTER //
// ./src/search/reducer.js